import {
  IClientDocSubmissionDetailsRequest,
  IClientDocSubmissionChangeRequest,
  IClientImagesRequest,
  IClientFormSubmissionChangeRequest,
  IClientAdditionalImagesRequest,
} from "./doc-validation-details.interface";
import { IIdentityDocument } from "../../../shared/models/identity.model";
import ApiClient, { updateRequestIdHeader } from "../../../configs/axios.kyc.config";
import { AxiosPromise } from "axios";

interface IGetDocumentsResponse {
  identityDocuments: IIdentityDocument[];
}

const DocValidationDetailsApi = {
  routes: {
    registrationDetails: "/registration/info",
    registrationChange: "/registration/status",
    registrationImage: "/registration/image",
    updateData: "/registration/edit/fields",
    additionalImage: "/registration/additional-images",
    identities: "/identity-documents",
  },

  methods: {
    getClientSubmissionDetails: ({ remoteId, username }: IClientDocSubmissionDetailsRequest): Promise<any> => {
      const url = DocValidationDetailsApi.routes.registrationDetails;

      const requestConfig = {
        submissionRequestId: remoteId,
        operator: username,
      };

      updateRequestIdHeader();
      return ApiClient.post(url, requestConfig);
    },

    getImageSubmissionDetails: (params: IClientImagesRequest) => {
      const { submissionRequestId, imageType } = params;
      const requestConfig = {
        submissionRequestId,
        imageType,
      };

      updateRequestIdHeader();
      return ApiClient.post(DocValidationDetailsApi.routes.registrationImage, requestConfig);
    },

    getAdditionalImageSubmissionDetails: (params: IClientAdditionalImagesRequest) => {
      const { submissionRequestId, imageType } = params;
      const requestConfig = {
        submissionRequestId,
        imageType,
      };

      updateRequestIdHeader();
      return ApiClient.post(DocValidationDetailsApi.routes.additionalImage, requestConfig);
    },

    changeClientSubmissionDetails: (requestId: string, params: IClientDocSubmissionChangeRequest): Promise<any> => {
      const requestConfig = {
        submissionRequestId: requestId,
        newStatus: params.status,
        comment: params.comment || "",
        customComment: params.customComment || "",
      };

      updateRequestIdHeader();
      return ApiClient.put(DocValidationDetailsApi.routes.registrationChange, requestConfig);
    },

    getDocuments: (): AxiosPromise<IGetDocumentsResponse> => {
      return ApiClient.get(DocValidationDetailsApi.routes.identities);
    },

    changeUpdateClientSubmissionDetails: (
      requestId: string,
      params: IClientFormSubmissionChangeRequest,
    ): Promise<any> => {
      //const isEdited = params.firstName?.status === "EDITED" || params.lastName?.status === "EDITED";
      const changedFields = Object.entries(params)
        .filter(([key, value]) => value?.status === "EDITED")
        .map(([key]) => key);
      const isEdited = changedFields.length > 0;
      const requestConfig = {
        submissionRequestId: requestId,
        workflow: "EDITED_BY_OPERATOR",
        status: isEdited ? "25" : "",
        operator: params.operator,
        documentType: params.documentType || "",
        comment: params.comment,
        firstName: {
          value: params.firstName?.value || "",
          status: params.firstName?.status,
        },
        lastName: {
          value: params.lastName?.value || "",
          status: params.lastName?.status,
        },
        documentNumber: {
          value: params.idNumber?.value || "",
          status: params.idNumber?.status,
        },
        dateOfBirth: {
          value: params.dateOfBirth?.value || "",
          status: params.dateOfBirth?.status,
        },
        placeOfBirth: {
          value: params.placeOfBirth?.value || "",
          status: params.placeOfBirth?.status,
        },
        gender: {
          value: params.gender?.value || "",
          status: params.gender?.status,
        },
        nationality: {
          value: params.nationality?.value || "",
          status: params.nationality?.status,
        },
        occupation: {
          value: params.occupation?.value || "",
          status: params.occupation?.status,
        },
        income: {
          value: params.income?.value || "",
          status: params.income?.status,
        },
        riskRating: {
          value: params.riskRating?.value || "",
          status: params.riskRating?.status,
        },
        idCardIssuingBy: {
          value: params.idCardIssuingBy?.value || "",
          status: params.idCardIssuingBy?.status,
        },
        idCardIssuingDate: {
          value: params.idCardIssuingDate?.value || "",
          status: params.idCardIssuingDate?.status,
        },
        idCardIssuingPlace: {
          value: params.idCardIssuingPlace?.value || "",
          status: params.idCardIssuingPlace?.status,
        },
        street: {
          value: params.street?.value || "",
          status: params.street?.status,
        },
        province: {
          value: params.province?.value || "",
          status: params.province?.status,
        },
        town: {
          value: params.town?.value || "",
          status: params.town?.status,
        },
        commune: {
          value: params.commune?.value || "",
          status: params.commune?.status,
        },
        changedFields,
      };
      updateRequestIdHeader();
      return ApiClient.put(DocValidationDetailsApi.routes.updateData, requestConfig);
    },
  },
};

export default DocValidationDetailsApi;
